import { getAccount } from "@wagmi/core";
import { ApiReportClientError } from "@/api";
import { wagmiConfig } from "@/config";
import { appEnv } from "@/config/env";
import { useUserStore } from "@/store/useUserStore";

declare const __APP_VERSION__: string;

function getUserAddress(): string {
  const fromStore = useUserStore.getState().userInfo?.address?.trim();
  if (fromStore) return fromStore;
  try {
    return getAccount(wagmiConfig).address ?? "";
  } catch {
    return "";
  }
}

function getPlatform(): string {
  const ua = navigator.userAgent;
  if (/TokenPocket|TPWallet|OKApp|OKX|Binance|BNC|MetaMask|imToken/i.test(ua)) {
    return "h5";
  }
  if (/Android/i.test(ua)) return "android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
    return "ios";
  }
  if (/Android|webOS|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(ua)) {
    return "h5";
  }
  return "web";
}

function serializeRawError(error: unknown): { message: string; stack: string } {
  if (error instanceof Error) {
    return {
      message: error.message || error.name || String(error),
      stack: error.stack ?? JSON.stringify(error, null, 2),
    };
  }
  if (typeof error === "string") {
    return { message: error, stack: error };
  }
  try {
    const text = JSON.stringify(error, null, 2);
    return { message: text, stack: text };
  } catch {
    const text = String(error);
    return { message: text, stack: text };
  }
}

/** 原样上报 error，不做合约错误匹配或 i18n 解析 */
export function reportRawClientErrorAsync(error: unknown): void {
  if (!error || typeof window === "undefined") return;

  const { message, stack } = serializeRawError(error);
  const now = Date.now();
  console.log("error-report", {
    message,
    stack,
    page: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    userAgent: navigator.userAgent,
    appVersion: `${__APP_VERSION__}-${appEnv}`,
    platform: getPlatform(),
    extra: JSON.stringify({
      userAddress: getUserAddress(),
      timestamp: now,
      timestampISO: new Date(now).toISOString(),
    }),
  });
  void ApiReportClientError({
    message,
    stack,
    page: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    userAgent: navigator.userAgent,
    appVersion: `${__APP_VERSION__}-${appEnv}`,
    platform: getPlatform(),
    extra: JSON.stringify({
      userAddress: getUserAddress(),
      timestamp: now,
      timestampISO: new Date(now).toISOString(),
    }),
  }).catch(err => {
    console.warn("[reportClientError]", err);
  });
}
